/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateExtraExpenseDto } from '../../models/create-extra-expense-dto';
import { ExtraIngredientExpense } from '../../models/extra-ingredient-expense';

export interface ExtraExpensesControllerCreate$Params {
      body: CreateExtraExpenseDto
}

export function extraExpensesControllerCreate(http: HttpClient, rootUrl: string, params: ExtraExpensesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ExtraIngredientExpense>> {
  const rb = new RequestBuilder(rootUrl, extraExpensesControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExtraIngredientExpense>;
    })
  );
}

extraExpensesControllerCreate.PATH = '/extra-expenses';
